import React from 'react';
import { Dropdown, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Avatar from 'components/common/Avatar';
import paths from 'routes/paths';
import { useAuth } from 'contexts/AuthContext';
import useLogout from 'hooks/useLogout';

const ProfileDropdown = () => {
  const { handleLogout } = useLogout();
  const { user, loading } = useAuth();  // get user & loading from AuthContext

  return (
    <Dropdown navbar as="li">
      <Dropdown.Toggle bsPrefix="toggle" as={Link} to="#!" className="pe-0 ps-2 nav-link">
        {loading ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <Avatar
            src={user?.profilePhoto || ''}
            alt={`${user?.firstName || ''} ${user?.lastName || ''}`}
            onError={e => {
              e.target.src = ''; // fallback if profilePhoto fails to load
            }}
          />
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} to={paths.userProfile}>
            Profile
          </Dropdown.Item>
          <Dropdown.Divider />

          <Dropdown.Item as={Link} to={paths.userSettings}>
            Settings
          </Dropdown.Item>
          <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
